import { EmptyBlock } from '../empty-block'
import { TextTableBlock } from './text-table-block'
import { TableBlock } from './table-block'
import { TABLE_TYPE } from './table.constants'

export function TableBlockViewer (props) {
  if (props.subtype === TABLE_TYPE.UNKNOWN) {
    return (
      <EmptyBlock>Empty Table Block</EmptyBlock>
    )
  } else if (props.subtype === TABLE_TYPE.TEXT) {
    return (
      <TextTableBlock {...props} />
    )
  } else {
    return (
      <TableBlock {...props} />
    )
  }
}
